import React from 'react';

// HamExpert mascot/logo: a little handheld radio with a face, arms and legs.
// Reused as the app logo (sidebar + login) and the Heraldo assistant icon.
export default function RadioBot(props) {
  var s = props.size || 32;
  return (
    <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
      {/* Antenna + radio waves */}
      <line x1="24" y1="15" x2="20" y2="4" stroke="#00d4ff" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="19" cy="3" r="3" fill="#ff6b9d" />
      <path d="M25 3 a5 5 0 0 1 4.5 3.5" stroke="#00d4ff" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.85" />
      {/* Legs + feet (behind body) */}
      <rect x="22" y="45" width="6" height="13" rx="3" fill="#7c89a8" />
      <rect x="36" y="45" width="6" height="13" rx="3" fill="#7c89a8" />
      <ellipse cx="23" cy="59" rx="6.5" ry="3" fill="#00d4ff" />
      <ellipse cx="41" cy="59" rx="6.5" ry="3" fill="#00d4ff" />
      {/* Arms + hands (behind body): left down, right waving up */}
      <rect x="6" y="28" width="6" height="16" rx="3" fill="#7c89a8" transform="rotate(14 9 36)" />
      <rect x="52" y="20" width="6" height="16" rx="3" fill="#7c89a8" transform="rotate(-28 55 28)" />
      <circle cx="7" cy="45" r="3.6" fill="#cbd5e8" />
      <circle cx="59" cy="19" r="3.6" fill="#cbd5e8" />
      {/* Body (the radio) */}
      <rect x="14" y="14" width="36" height="34" rx="9" fill="#d3dcec" stroke="#aab6d0" strokeWidth="1" />
      {/* Top knobs */}
      <circle cx="39" cy="17.5" r="2" fill="#7c89a8" />
      <circle cx="45" cy="17.5" r="2" fill="#7c89a8" />
      {/* Face screen */}
      <rect x="19" y="21" width="26" height="15" rx="5" fill="#10204a" />
      <circle cx="27" cy="28" r="3" fill="#00d4ff" />
      <circle cx="37" cy="28" r="3" fill="#00d4ff" />
      <path d="M27 32.5 q5 4 10 0" stroke="#00d4ff" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      {/* Speaker grille */}
      <rect x="22" y="39.5" width="20" height="2" rx="1" fill="#9aa7c4" />
      <rect x="22" y="43.5" width="20" height="2" rx="1" fill="#9aa7c4" />
    </svg>
  );
}
